import { useMutation, useQueryClient } from '@tanstack/react-query';
import { purchaseRequisitionService } from '@/services/purchaseRequisitionService';
import type { CancelPurchaseRequisitionLineItemRequest } from '@/services/purchaseRequisitionService';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';
import { queryKeys } from '@/lib/queryKeys';

export const useCancelPurchaseRequisitionLineItem = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (request: CancelPurchaseRequisitionLineItemRequest) =>
      purchaseRequisitionService.cancelPurchaseRequisitionLineItem(request),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.orders.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.orders.lineItems(data.orderId) });
      notifications.success(
        'Line Item Updated',
        `Purchase requisition ${data.orderIdentifier} updated successfully`,
      );
    },
    onError: (error: unknown) => {
      const message = getErrorMessage(error);
      notifications.error('Line Item Update Failed', message);
    },
  });
};
